import { emptyApi } from "./emptyApi";

export type InitiateSalesTaxRegistrationResponse = {
  state_registration_id: string;
  state_id: string;
  state: string;
  status: string;
  group_id: string;
};

export const salesTaxRegistrationDetails = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    initiateSalesTaxRegistration: build.mutation<
      InitiateSalesTaxRegistrationResponse,
      { entityId: string; registrationId: string }
    >({
      query: ({ entityId, registrationId }) => ({
        url: `/api/inkle/salestax/entity/${entityId}/registrations/${registrationId}/details/`,
        method: "POST",
      }),
      invalidatesTags: (result) =>
        result ? ["SALES_TAX_REGISTRATIONS", "CART"] : [],
    }),
    initiateRegistrationForState: build.mutation<
      InitiateSalesTaxRegistrationResponse,
      { entityId: string; stateId: string }
    >({
      query: ({ entityId, stateId }) => ({
        url: `/api/inkle/salestax/entity/${entityId}/registrations/state/${stateId}/initiate/`,
        method: "POST",
      }),
      invalidatesTags: (result) =>
        result ? ["SALES_TAX_REGISTRATIONS", "CART"] : [],
    }),
  }),
});

export const {
  useInitiateSalesTaxRegistrationMutation,
  useInitiateRegistrationForStateMutation,
} = salesTaxRegistrationDetails;
